import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { NewsletterSignup } from "@/components/NewsletterSignup";
import { NAV, ENQUIRE, CONTACT, LEGAL_NAV } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-primary text-primary-foreground">
    <div className="edge grid grid-cols-1 gap-y-14 border-b border-white/10 py-20 md:grid-cols-12 md:gap-8">
      <div className="md:col-span-5">
        <Logo dark className="mb-8" size="h-12 md:h-14" />
        <p className="max-w-sm text-sm leading-relaxed text-primary-foreground/60">
          House of David is Auckland's purveyor of fine interior materials —
          supplying timber, stone and architectural surfaces to New Zealand's
          designers and builders.
        </p>
        <NewsletterSignup />
      </div>

      <div className="md:col-span-3 md:col-start-7">
        <p className="eyebrow mb-6 text-primary-foreground/50">Navigate</p>
        <ul className="space-y-3">
          {NAV.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                data-testid={`footer-nav-${item.id}`}
                className="text-sm text-primary-foreground/80 transition-colors hover:text-primary-foreground"
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to={ENQUIRE.to}
              data-testid="footer-nav-enquire"
              className="text-sm text-primary-foreground/80 transition-colors hover:text-primary-foreground"
            >
              Enquire
            </Link>
          </li>
          <li>
            <Link
              to="/brochures"
              data-testid="footer-nav-brochures"
              className="text-sm text-primary-foreground/80 transition-colors hover:text-primary-foreground"
            >
              Brochures
            </Link>
          </li>
        </ul>
      </div>

      <div className="md:col-span-3">
        <p className="eyebrow mb-6 text-primary-foreground/50">Our Office</p>
        <address className="space-y-3 not-italic text-sm text-primary-foreground/80">
          {CONTACT.address.map((line) => (
            <p key={line}>{line}</p>
          ))}
          <p>
            <a href={`mailto:${CONTACT.email}`} className="hover:text-primary-foreground">
              {CONTACT.email}
            </a>
          </p>
          <p>{CONTACT.phone}</p>
        </address>
        <div className="mt-6 flex gap-5">
          {CONTACT.socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`footer-social-${s.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.16em] text-primary-foreground/60 hover:text-primary-foreground"
            >
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </div>

    <div className="edge flex flex-wrap gap-x-8 gap-y-3 border-b border-white/10 py-6">
      {LEGAL_NAV.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={`footer-legal-${l.to.replace("/", "")}`}
          className="text-xs uppercase tracking-[0.14em] text-primary-foreground/60 transition-colors hover:text-primary-foreground"
        >
          {l.label}
        </Link>
      ))}
    </div>

    <div className="edge flex flex-col gap-2 py-8 text-xs text-primary-foreground/50 md:flex-row md:items-center md:justify-between">
      <span>© {new Date().getFullYear()} House of David. All rights reserved.</span>
      <span className="uppercase tracking-[0.18em]">Timber · Architectural Stone · Custom Carpet</span>
    </div>
  </footer>
);
